import React from 'react'
import { Helmet } from 'react-helmet'
import { LazyLoadImage } from 'react-lazy-load-image-component'

export default function About() {
  return (
        <>
 {/* Meta Tags for SEO */}
      <Helmet>
  <title>About Us - V Hotel The Grand Shoba</title>

  {/* <!-- Meta Description with keywords --> */}
  <meta name="description" content="V Hotel The Grand Shoba near IGI Airport, Delhi offers luxury rooms, fine dining, banquet halls, wellness club, and modern amenities. Ideal for travelers, weddings, and business events." />
  
  {/* <!-- Keywords for SEO --> */}
  <meta name="keywords" content="hotel near IGI Airport Delhi, luxury hotel Mahipalpur, banquet hall Delhi airport, wellness club, restaurant near airport, business hotel Delhi, 5-star hotel near IGI" />

  {/* <!-- Open Graph for social sharing --> */}
  <meta property="og:title" content="About Us - V Hotel The Grand Shoba" />
  <meta property="og:description" content="Discover V Hotel The Grand Shoba—luxury and comfort near Delhi Airport. Perfect for business, weddings, and leisure stays." />
  <meta property="og:image" content="images/hotel-img.jpg" />
</Helmet>


<div className="container">
            <div className="container-fluid ">
            
    <div className="row align-items-center ">
      <div className="col-md-6 col-12 col-sm-6">
        <div className="about-img-div">
        <LazyLoadImage src="/images/home/hotel-img.jpg" className="img-fluid1 rounded" alt="V Hotel The Grnad Shoba front view" title='Welcome to V Hotel
The Grand Shoba'/>
        </div>
      </div>
      <div className="col-md-6 col-sm-6 col-12 about-description" id='about'>
        <h1>Welcome to V Hotel </h1>
        <h2 > The Grand Shoba</h2>
        <p>
        Located just minutes from Indira Gandhi International Airport near Terminals 2 and 3. V Hotel The Grand Shoba in Mahipalpur and Vasant Kunj offers ideal convenience for international, domestic, and connecting flight travelers.
          </p>
          <p>Our luxury hotel features 100 elegant rooms and suites with modern amenities, perfect for business and leisure stays. 
</p>
<p>
Dine at our signature restaurants—Safar, Zaika, Aerostag, and Udaan—serving global and Indian cuisine curated by expert chefs. 

</p>
<p>Host unforgettable weddings, meetings, or events in our banquet and conference halls near IGI Airport. 
Relax by the infinity pool or unwind at our wellness club. With exceptional service and comfort, your stay is designed to be both memorable and seamless.
</p>
      </div>
    </div>
  </div>
            </div>
        </>
  )
}
